import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useStaffAuth } from '../../context/StaffAuthContext';
import { Plane, IndianRupee, Search, ClipboardList, Wallet } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function StaffDashboard() {
  const { staff } = useStaffAuth();
  const [stats, setStats] = useState({ todayCount: 0, todayCollection: 0 });

  useEffect(() => {
    const today = new Date().toISOString().slice(0, 10);
    axios
      .get(`${BACKEND_URL}/api/staff/bookings`, {
        params: { from_date: today, to_date: today, limit: 200 },
        withCredentials: true,
      })
      .then((res) => {
        const rows = res.data.rows || [];
        const collection = rows.reduce((sum, b) => sum + Number(b.total_amount || 0), 0);
        setStats({ todayCount: rows.length, todayCollection: collection });
      })
      .catch(() => {});
  }, []);

  const cards = [
    { icon: Plane, label: "Today's bookings", value: stats.todayCount, color: 'text-[#1B375B]' },
    { icon: IndianRupee, label: "Today's collection", value: `₹${stats.todayCollection.toLocaleString('en-IN')}`, color: 'text-emerald-700' },
    { icon: Wallet, label: 'Cash drawer', value: 'Not open (P2)', color: 'text-gray-500' },
  ];

  return (
    <div className="p-6 max-w-5xl mx-auto" data-testid="staff-dashboard">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-[#1B375B]">Welcome, {staff?.full_name}</h1>
        <p className="text-sm text-gray-500">
          {staff?.role} · {staff?.branch_name || staff?.branch_city || 'Branch'}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {cards.map(({ icon: Icon, label, value, color }) => (
          <div key={label} className="bg-white rounded-xl border border-gray-200 p-5">
            <div className="flex items-center gap-3 mb-2">
              <Icon className={`w-5 h-5 ${color}`} />
              <span className="text-xs uppercase font-semibold text-gray-500">{label}</span>
            </div>
            <p className={`text-2xl font-bold ${color}`}>{value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Link to="/staff/search" className="flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-5 hover:border-[#659A9B] transition-colors">
          <Search className="w-8 h-8 text-[#659A9B]" />
          <div>
            <p className="font-bold text-[#1B375B]">Search & Book</p>
            <p className="text-xs text-gray-500">B2C pricing with margin visibility</p>
          </div>
        </Link>
        <Link to="/staff/bookings" className="flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-5 hover:border-[#659A9B] transition-colors">
          <ClipboardList className="w-8 h-8 text-[#659A9B]" />
          <div>
            <p className="font-bold text-[#1B375B]">My Bookings</p>
            <p className="text-xs text-gray-500">Counter sales history</p>
          </div>
        </Link>
      </div>
    </div>
  );
}
